import React, { useState } from 'react';
import { Camera, Mail, Lock, User, Bell, Globe, Shield, CheckCircle2 } from 'lucide-react';
export function Profile() {
  const [activeTab, setActiveTab] = useState('general');
  const [isSaved, setIsSaved] = useState(false);
  const handleSave = (e: React.FormEvent) => {
    e.preventDefault();
    setIsSaved(true);
    setTimeout(() => setIsSaved(false), 3000);
  };
  return <div className="space-y-8 animate-in fade-in duration-500 max-w-4xl" data-id="element-1795" data-mp="s9mb1xy25rr">
      <div data-id="element-1796" data-mp="4tuui9zj9vvm">
        <h1 className="text-2xl font-semibold text-slate-900" data-id="element-1797" data-mp="4umppjp7xrld">Your Profile</h1>
        <p className="text-slate-500 mt-1" data-id="element-1798" data-mp="3mzpypfib2nr2">
          Manage your personal information and preferences.
        </p>
      </div>

      <div className="flex flex-col md:flex-row gap-8" data-id="element-1799" data-mp="3ry185p4ouw8r">
        {/* Profile Nav */}
        <div className="w-full md:w-64 shrink-0" data-id="element-1800" data-mp="2bk1ciqcvlsrb">
          <nav className="space-y-1" data-id="element-1801" data-mp="2bj9e77rw9gxc">
            <button onClick={() => setActiveTab('general')} className={`w-full flex items-center px-3 py-2.5 rounded-md text-sm font-medium transition-colors ${activeTab === 'general' ? 'bg-slate-100 text-slate-900' : 'text-slate-600 hover:bg-slate-50 hover:text-slate-900'}`} data-id="element-1802" data-mp="2gjdyz9zu4xtd">
              <User className={`h-4 w-4 mr-3 ${activeTab === 'general' ? 'text-slate-700' : 'text-slate-400'}`} data-id="element-1803" data-mp="2k447es0zproe" />
              General Info
            </button>
            <button onClick={() => setActiveTab('security')} className={`w-full flex items-center px-3 py-2.5 rounded-md text-sm font-medium transition-colors ${activeTab === 'security' ? 'bg-slate-100 text-slate-900' : 'text-slate-600 hover:bg-slate-50 hover:text-slate-900'}`} data-id="element-1804" data-mp="2t40oo8l1vo9f">
              <Shield className={`h-4 w-4 mr-3 ${activeTab === 'security' ? 'text-slate-700' : 'text-slate-400'}`} data-id="element-1805" data-mp="2xwag5t1tcwdt" />
              Security & Password
            </button>
            <button onClick={() => setActiveTab('preferences')} className={`w-full flex items-center px-3 py-2.5 rounded-md text-sm font-medium transition-colors ${activeTab === 'preferences' ? 'bg-slate-100 text-slate-900' : 'text-slate-600 hover:bg-slate-50 hover:text-slate-900'}`} data-id="element-1806" data-mp="37uq4jo9ghrjm">
              <Bell className={`h-4 w-4 mr-3 ${activeTab === 'preferences' ? 'text-slate-700' : 'text-slate-400'}`} data-id="element-1807" data-mp="3ospytfuuw2iu" />
              Preferences
            </button>
          </nav>
        </div>

        {/* Profile Content */}
        <div className="flex-1 space-y-6" data-id="element-1808" data-mp="6g1w9hlfuj4e">
          {activeTab === 'general' && <div className="bg-white border border-slate-200 rounded-xl shadow-sm overflow-hidden animate-in fade-in" data-id="element-1809" data-mp="bfejw4k4vu81">
              <div className="p-6 border-b border-slate-200" data-id="element-1810" data-mp="gdy7saiafg31">
                <h2 className="text-lg font-medium text-slate-900" data-id="element-1811" data-mp="2d79hxhdgw07s">
                  General Information
                </h2>
                <p className="text-sm text-slate-500 mt-1" data-id="element-1812" data-mp="2i5kqzpvxu6oy">
                  Update your photo and personal details.
                </p>
              </div>

              <form onSubmit={handleSave} data-id="element-1813" data-mp="2aoo8izb63sp3">
                <div className="p-6 space-y-6" data-id="element-1814" data-mp="25v3hjr7zryze">
                  {/* Avatar Upload */}
                  <div className="flex items-center space-x-6" data-id="element-1815" data-mp="20w8olwgb8u1k">
                    <div className="relative" data-id="element-1816" data-mp="20up57wzcy2vk">
                      <div className="w-24 h-24 rounded-full bg-slate-200 flex items-center justify-center text-2xl font-medium text-slate-600 overflow-hidden border-2 border-white shadow-sm" data-id="element-1817" data-mp="1vz03bmzv89w3">
                        JD
                      </div>
                      <button type="button" className="absolute bottom-0 right-0 bg-white border border-slate-200 p-1.5 rounded-full shadow-sm text-slate-600 hover:text-slate-900 hover:bg-slate-50 transition-colors" data-id="element-1818" data-mp="2okryggf0devr">
                        <Camera className="h-4 w-4" data-id="element-1819" data-mp="1869w1r2wqes5" />
                      </button>
                    </div>
                    <div data-id="element-1820" data-mp="13bme6b2esimj">
                      <h3 className="text-sm font-medium text-slate-900" data-id="element-1821" data-mp="2s2xibniyan02">
                        Profile Photo
                      </h3>
                      <p className="text-xs text-slate-500 mt-1 mb-3" data-id="element-1822" data-mp="2wvqn2bef5vc5">
                        JPG, GIF or PNG. Max size of 2MB.
                      </p>
                      <div className="flex space-x-3" data-id="element-1823" data-mp="2n44buf22zw9e">
                        <button type="button" className="bg-white border border-slate-200 text-slate-700 px-3 py-1.5 rounded-md text-sm font-medium hover:bg-slate-50 transition-colors" data-id="element-1824" data-mp="2n4nkf55ud8ar">
                          Upload New
                        </button>
                        <button type="button" className="text-slate-500 hover:text-red-600 text-sm font-medium transition-colors" data-id="element-1825" data-mp="35uvmrl1pvupw">
                          Remove
                        </button>
                      </div>
                    </div>
                  </div>

                  <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-1826" data-mp="cgio9zelgiyh">
                    <div data-id="element-1827" data-mp="7js8ld6pbpdl">
                      <label className="block text-sm font-medium text-slate-700 mb-1" data-id="element-1828" data-mp="7ih4fc9cgfly">
                        First Name
                      </label>
                      <input type="text" defaultValue="Jane" className="w-full px-3 py-2 border border-slate-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-slate-900 focus:border-slate-900 sm:text-sm" data-id="element-1829" data-mp="hhg80gf95l23" />
                    </div>
                    <div data-id="element-1830" data-mp="2lh0b6w21mxh">
                      <label className="block text-sm font-medium text-slate-700 mb-1" data-id="element-1831" data-mp="2lqr2woxby48">
                        Last Name
                      </label>
                      <input type="text" defaultValue="Doe" className="w-full px-3 py-2 border border-slate-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-slate-900 focus:border-slate-900 sm:text-sm" data-id="element-1832" data-mp="367xszdtj6vmu" />
                    </div>
                    <div className="md:col-span-2" data-id="element-1833" data-mp="1a3rpprhkzou1">
                      <label className="block text-sm font-medium text-slate-700 mb-1" data-id="element-1834" data-mp="1exm72o9prrpy">
                        Email Address
                      </label>
                      <div className="relative rounded-md shadow-sm" data-id="element-1835" data-mp="1jxibgombpl61">
                        <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none" data-id="element-1836" data-mp="m9gp29a1ogtt">
                          <Mail className="h-4 w-4 text-slate-400" data-id="element-1837" data-mp="r92zkayhniyx" />
                        </div>
                        <input type="email" defaultValue="jane.doe@example.com" className="w-full pl-10 pr-3 py-2 border border-slate-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-slate-900 focus:border-slate-900 sm:text-sm" data-id="element-1838" data-mp="w865ryq7fv8h" />
                      </div>
                    </div>
                    <div className="md:col-span-2" data-id="element-1839" data-mp="z2hzjhqdzx2">
                      <label className="block text-sm font-medium text-slate-700 mb-1" data-id="element-1840" data-mp="3s311v4ot4uce">
                        Job Title
                      </label>
                      <input type="text" defaultValue="Program Manager" className="w-full px-3 py-2 border border-slate-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-slate-900 focus:border-slate-900 sm:text-sm" data-id="element-1841" data-mp="3na7tm6u4r3vk" />
                    </div>
                  </div>
                </div>
                <div className="bg-slate-50 px-6 py-4 border-t border-slate-200 flex justify-between items-center" data-id="element-1842" data-mp="34fjfjoobaogt">
                  {isSaved ? <span className="text-emerald-600 text-sm font-medium flex items-center" data-id="element-1843" data-mp="12lacpbahxrwb">
                      <CheckCircle2 className="h-4 w-4 mr-1.5" data-id="element-1844" data-mp="xmz0itwqb5ax" /> Saved
                      successfully
                    </span> : <span data-id="element-1845" data-mp="6k8x4bfmfrp8"></span>}
                  <button type="submit" className="bg-slate-900 text-white px-4 py-2 rounded-md text-sm font-medium hover:bg-slate-800 transition-colors" data-id="element-1846" data-mp="bfy24uaeu0sx">
                    Save Changes
                  </button>
                </div>
              </form>
            </div>}

          {activeTab === 'security' && <div className="bg-white border border-slate-200 rounded-xl shadow-sm overflow-hidden animate-in fade-in" data-id="element-1847" data-mp="3ow5nkib1q63s">
              <div className="p-6 border-b border-slate-200" data-id="element-1848" data-mp="39zwq9mapu2u0">
                <h2 className="text-lg font-medium text-slate-900" data-id="element-1849" data-mp="3ex6e4xigi6fq">
                  Change Password
                </h2>
                <p className="text-sm text-slate-500 mt-1" data-id="element-1850" data-mp="188bdxkve9hu5">
                  Ensure your account is using a long, random password to stay
                  secure.
                </p>
              </div>

              <form onSubmit={handleSave} data-id="element-1851" data-mp="2xp5i9bnnsfn5">
                <div className="p-6 space-y-6" data-id="element-1852" data-mp="2xm13jkcki1i8">
                  <div data-id="element-1853" data-mp="2sqc21bgzmaja">
                    <label className="block text-sm font-medium text-slate-700 mb-1" data-id="element-1854" data-mp="2sr40cu1yymd9">
                      Current Password
                    </label>
                    <div className="relative rounded-md shadow-sm" data-id="element-1855" data-mp="32mylpwxkuvjq">
                      <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none" data-id="element-1856" data-mp="32lniby81npt5">
                        <Lock className="h-4 w-4 text-slate-400" data-id="element-1857" data-mp="3cda2ik2d0z81" />
                      </div>
                      <input type="password" className="w-full pl-10 pr-3 py-2 border border-slate-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-slate-900 focus:border-slate-900 sm:text-sm" data-id="element-1858" data-mp="3qd1b25a3xnen" />
                    </div>
                  </div>
                  <div className="border-t border-slate-100 pt-6" data-id="element-1859" data-mp="1r0qjdggb2bw4">
                    <label className="block text-sm font-medium text-slate-700 mb-1" data-id="element-1860" data-mp="2mlfse4x115d9">
                      New Password
                    </label>
                    <div className="relative rounded-md shadow-sm" data-id="element-1861" data-mp="2hll1i1d94fs7">
                      <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none" data-id="element-1862" data-mp="2cmq8k6lklaud">
                        <Lock className="h-4 w-4 text-slate-400" data-id="element-1863" data-mp="28mg3cw5lqogk" />
                      </div>
                      <input type="password" className="w-full pl-10 pr-3 py-2 border border-slate-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-slate-900 focus:border-slate-900 sm:text-sm" data-id="element-1864" data-mp="35c6vwpuc21jq" />
                    </div>
                    <p className="text-xs text-slate-500 mt-2" data-id="element-1865" data-mp="2rjh94j6zcslk">
                      Password must be at least 8 characters long and contain a
                      mix of letters, numbers, and symbols.
                    </p>
                  </div>
                  <div data-id="element-1866" data-mp="3j9vhy104zeqd">
                    <label className="block text-sm font-medium text-slate-700 mb-1" data-id="element-1867" data-mp="15tbzw0jwi5w1">
                      Confirm New Password
                    </label>
                    <div className="relative rounded-md shadow-sm" data-id="element-1868" data-mp="1asf2leces00u">
                      <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none" data-id="element-1869" data-mp="1esp5uj8tgcc0">
                        <Lock className="h-4 w-4 text-slate-400" data-id="element-1870" data-mp="1jtmoewxqn8e1" />
                      </div>
                      <input type="password" className="w-full pl-10 pr-3 py-2 border border-slate-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-slate-900 focus:border-slate-900 sm:text-sm" data-id="element-1871" data-mp="1or4zotz89zp7" />
                    </div>
                  </div>
                </div>
                <div className="bg-slate-50 px-6 py-4 border-t border-slate-200 flex justify-between items-center" data-id="element-1872" data-mp="27ifqzc8v8ehm">
                  {isSaved ? <span className="text-emerald-600 text-sm font-medium flex items-center" data-id="element-1873" data-mp="2ciagpcgwmy13">
                      <CheckCircle2 className="h-4 w-4 mr-1.5" data-id="element-1874" data-mp="cg14di6hyjez" /> Password
                      updated
                    </span> : <span data-id="element-1875" data-mp="m52mbdwlravl"></span>}
                  <button type="submit" className="bg-slate-900 text-white px-4 py-2 rounded-md text-sm font-medium hover:bg-slate-800 transition-colors" data-id="element-1876" data-mp="m6ndqunmedp8">
                    Update Password
                  </button>
                </div>
              </form>
            </div>}

          {activeTab === 'preferences' && <div className="bg-white border border-slate-200 rounded-xl shadow-sm overflow-hidden animate-in fade-in" data-id="element-1877" data-mp="152lxan2mf3kn">
              <div className="p-6 border-b border-slate-200" data-id="element-1878" data-mp="105n0fwrkoiir">
                <h2 className="text-lg font-medium text-slate-900" data-id="element-1879" data-mp="36wcrt5gi1vgv">
                  User Preferences
                </h2>
                <p className="text-sm text-slate-500 mt-1" data-id="element-1880" data-mp="31xrsd892nfth">
                  Customize your experience and notifications.
                </p>
              </div>

              <form onSubmit={handleSave} data-id="element-1881" data-mp="1mdsklutis8c4">
                <div className="p-6 space-y-8" data-id="element-1882" data-mp="1mchcxjwyegfq">
                  {/* Notifications */}
                  <div data-id="element-1883" data-mp="17ntl9oq8aqv2">
                    <h3 className="text-sm font-medium text-slate-900 mb-4 flex items-center" data-id="element-1884" data-mp="17mijfugcft6l">
                      <Bell className="h-4 w-4 mr-2 text-slate-500" data-id="element-1885" data-mp="1clcyqmf3qzly" />
                      Email Notifications
                    </h3>
                    <div className="space-y-4" data-id="element-1886" data-mp="13natfuoc5ksv">
                      <div className="flex items-start" data-id="element-1887" data-mp="13o2q78to5okq">
                        <div className="flex items-center h-5" data-id="element-1888" data-mp="oqab2hs1b272">
                          <input id="notif-assessments" type="checkbox" defaultChecked className="h-4 w-4 text-slate-900 focus:ring-slate-900 border-slate-300 rounded" data-id="element-1889" data-mp="orv23xf54306" />
                        </div>
                        <div className="ml-3 text-sm" data-id="element-1890" data-mp="o0n05efwi6cn">
                          <label htmlFor="notif-assessments" className="font-medium text-slate-700" data-id="element-1891" data-mp="ny0qn99g9grs">
                            Assessment Updates
                          </label>
                          <p className="text-slate-500" data-id="element-1892" data-mp="a02fecqfe0gi">
                            Get notified when a new assessment cycle starts or
                            ends.
                          </p>
                        </div>
                      </div>
                      <div className="flex items-start" data-id="element-1893" data-mp="3sebmmtfvgj6j">
                        <div className="flex items-center h-5" data-id="element-1894" data-mp="3setgjjf2alba">
                          <input id="notif-evaluations" type="checkbox" defaultChecked className="h-4 w-4 text-slate-900 focus:ring-slate-900 border-slate-300 rounded" data-id="element-1895" data-mp="3ngjm5b15voqq" />
                        </div>
                        <div className="ml-3 text-sm" data-id="element-1896" data-mp="33fgmzxb07on0">
                          <label htmlFor="notif-evaluations" className="font-medium text-slate-700" data-id="element-1897" data-mp="38bnuvvmyna7l">
                            Evaluation Requests
                          </label>
                          <p className="text-slate-500" data-id="element-1898" data-mp="2kmwavrjixy5w">
                            Get notified when you are nominated as an evaluator.
                          </p>
                        </div>
                      </div>
                      <div className="flex items-start" data-id="element-1899" data-mp="2ukiugrbrqdw7">
                        <div className="flex items-center h-5" data-id="element-1900" data-mp="2uizd0xedlwsu">
                          <input id="notif-reports" type="checkbox" defaultChecked className="h-4 w-4 text-slate-900 focus:ring-slate-900 border-slate-300 rounded" data-id="element-1901" data-mp="2zck9um48gkqg" />
                        </div>
                        <div className="ml-3 text-sm" data-id="element-1902" data-mp="1yspaa61tg9o7">
                          <label htmlFor="notif-reports" className="font-medium text-slate-700" data-id="element-1903" data-mp="1tunqtk0ha8c7">
                            Report Availability
                          </label>
                          <p className="text-slate-500" data-id="element-1904" data-mp="1fvxonpysxigz">
                            Get notified when your personal report is ready to
                            view.
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="border-t border-slate-100 pt-6" data-id="element-1905" data-mp="1kvabwbtl4rk3">
                    <h3 className="text-sm font-medium text-slate-900 mb-4 flex items-center" data-id="element-1906" data-mp="1kx3lnzzhvrwb">
                      <Globe className="h-4 w-4 mr-2 text-slate-500" data-id="element-1907" data-mp="31bdaswbk9ko7" />
                      Regional Settings
                    </h3>
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-1908" data-mp="33tyi98uavi49">
                      <div data-id="element-1909" data-mp="33w1hmjhcenln">
                        <label className="block text-sm font-medium text-slate-700 mb-1" data-id="element-1910" data-mp="38tb69wwwqv8f">
                          Language
                        </label>
                        <select className="w-full px-3 py-2 border border-slate-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-slate-900 focus:border-slate-900 sm:text-sm bg-white" data-id="element-1911" data-mp="2uv3dm16wmg32">
                          <option data-id="element-1912" data-mp="3mm9fon66qnuz">English (US)</option>
                          <option data-id="element-1913" data-mp="3ri7ylv8qvdo0">English (UK)</option>
                          <option data-id="element-1914" data-mp="3rl41lxzg8sjb">Spanish</option>
                          <option data-id="element-1915" data-mp="3dr37xinctvpt">French</option>
                        </select>
                      </div>
                      <div data-id="element-1916" data-mp="3hs56rydd05r9">
                        <label className="block text-sm font-medium text-slate-700 mb-1" data-id="element-1917" data-mp="3hrdfgzqsou6s">
                          Timezone
                        </label>
                        <select className="w-full px-3 py-2 border border-slate-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-slate-900 focus:border-slate-900 sm:text-sm bg-white" data-id="element-1918" data-mp="e5em5yba2ftk">
                          <option data-id="element-1919" data-mp="3grmlbww4becp">Pacific Time (PT)</option>
                          <option data-id="element-1920" data-mp="3bt1v8qakyb1z">Eastern Time (ET)</option>
                          <option data-id="element-1921" data-mp="3btl0p7j1n6z4">Central Time (CT)</option>
                          <option data-id="element-1922" data-mp="36v021cjfwvcs">Greenwich Mean Time (GMT)</option>
                        </select>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="bg-slate-50 px-6 py-4 border-t border-slate-200 flex justify-between items-center" data-id="element-1923" data-mp="3d8dy98fcvjv">
                  {isSaved ? <span className="text-emerald-600 text-sm font-medium flex items-center" data-id="element-1924" data-mp="3ulw18uq86su2">
                      <CheckCircle2 className="h-4 w-4 mr-1.5" data-id="element-1925" data-mp="3pkgbipd3ry5c" /> Preferences
                      saved
                    </span> : <span data-id="element-1926" data-mp="2e59uxng86tq6"></span>}
                  <button type="submit" className="bg-slate-900 text-white px-4 py-2 rounded-md text-sm font-medium hover:bg-slate-800 transition-colors" data-id="element-1927" data-mp="2e7nmvnflzpti">
                    Save Preferences
                  </button>
                </div>
              </form>
            </div>}
        </div>
      </div>
    </div>;
}